import { render } from "./AccountChooser.vue?vue&type=template&id=035be753&scoped=true"
import script from "./AccountChooser.vue?vue&type=script&lang=js"
export * from "./AccountChooser.vue?vue&type=script&lang=js"

import "./AccountChooser.vue?vue&type=style&index=0&id=035be753&scoped=true&lang=css"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035be753"]])

export default __exports__